export enum TagTypeEnum {
  COLLECTION = 'collections',
  HASHTAG = 'hashtags'
}
